import moment from 'moment'

export default {
  // Basis Informationen des Model
  model: {
    id: 0,
    name: '',
    permission_id: 0,

    permissions: {
      dashboard: 0,
      deceaseds: 0,
      customers: 0,
      graves: 0,
      areas: 0,
      crematories: 0,
      undertakers: 0,
      users: 0,
      roles: 0,

      area_categories: 0,
      grave_categories: 0,
      burial_types: 0,
      denominations: 0
    },

    permissionsValues: {
      dashboard: '',
      deceaseds: '',
      customers: '',
      graves: '',
      areas: '',
      crematories: '',
      undertakers: '',
      users: '',
      roles: '',

      area_categories: '',
      grave_categories: '',
      burial_types: '',
      denominations: ''
    }
  },

  clear (aDefaultValue) {
    const defaultValue = typeof aDefaultValue === 'undefined' ? 0 : aDefaultValue

    this.model.id = 0
    this.model.name = ''
    this.model.permission_id = ''

    this.model.forced = true

    this.model.permissions = {
      dashboard: defaultValue,
      deceaseds: defaultValue,
      customers: defaultValue,
      graves: defaultValue,
      areas: defaultValue,
      crematories: defaultValue,
      undertakers: defaultValue,
      users: defaultValue,
      roles: defaultValue,

      area_categories: defaultValue,
      grave_categories: defaultValue,
      burial_types: defaultValue,
      denominations: defaultValue
    }

    this.model.permissionsValues = {
      dashboard: '',
      deceaseds: '',
      customers: '',
      graves: '',
      areas: '',
      crematories: '',
      undertakers: '',
      users: '',
      roles: '',

      area_categories: '',
      grave_categories: '',
      burial_types: '',
      denominations: ''
    }
  },

  name: 'roles',

  // Die Spalten der Tabelle
  cols: [
    {name: 'Vorname', json: 'firstname', type: 'text'},
    {name: 'Nachname', json: 'lastname', type: 'text'}
  ],

  relations: [
    'users'
  ],

  copy (aModel) {
    this.model.id = aModel.id
    this.model.name = aModel.name
    this.model.permission_id = aModel.permission_id

    this.model.permissions = aModel.permissions
    this.model.permissionsValues = typeof aModel.permissionsValues === 'undefined' ? {
      dashboard: '',
      deceaseds: '',
      customers: '',
      graves: '',
      areas: '',
      crematories: '',
      undertakers: '',
      users: '',
      roles: '',

      area_categories: '',
      grave_categories: '',
      burial_types: '',
      denominations: ''
    } : aModel.permissionsValues
  },

  validate () {
    return true
  },

	validateModel () {
		return true
	},

	// Beziehungen zu anderen Models
  users: []
}



// WEBPACK FOOTER //
// ./src/models/roles.js